import { isFalsy } from 'lib/Helpers';
import { sortByPropAscendingCaseInsensitive } from 'lib/Sorting';

const attachLocationsDataToSegment = ({ segment, locations }) => {
  const { metaData: { locations: { siteUuids } } } = segment;

  if (isFalsy(siteUuids)) return { ...segment, locationData: [] };
  /* Convert Array of Locations into a Map */
  const cache = locations.reduce((acc, loc) => {
    return { ...acc, [loc.id]: loc };
  }, {});

  return {
    ...segment,
    locationData: sortByPropAscendingCaseInsensitive(siteUuids.map(uuid => cache[uuid]), 'city'),
  };
};

export default attachLocationsDataToSegment;
